import React from 'react';
import { observer, inject } from 'mobx-react';
import { FirebaseAuthService } from '../services/AuthService';
import { Button, Header, Message } from 'semantic-ui-react';
import LearnMore from './LearnMore';
import PAYEarned from './PAYEarned';
import PaymentService, { Subscription } from '../services/PaymentService';
import { Link } from 'react-router-dom';
import { ProjectJSON } from '../schemas/projects/ProjectJSON';

interface FreeAccountMessageProps {
  auth?: FirebaseAuthService;
  payment?: PaymentService;
  subscriptions: Array<Subscription> | undefined;
  projects?: Array<ProjectJSON>;
}

@inject('auth')
@observer
export default class FreeAccountMessage extends React.Component<FreeAccountMessageProps> {
  render(): React.ReactNode {
    if (
      (
        // If auth and payment service are not initialized, show nothing
        !this.props.auth?.initialized
      ) || (
        // If auth and payment service are initialized but the user is subscribed, show nothing
        this.props.auth?.initialized
        && this.props.subscriptions?.length
      )  || (this.props.projects && this.props.projects?.length > 0)
    ) {
      return '';
    }

    // return (
    //   <Message warning className='free-account-warning'>
    //     <Message.Header><PAYEarned/> Free Limited Account</Message.Header>
    //     <p>
    //       You are using the Free Limited Account.  With your Free Limited Account, you can begin entering project
    //       information and learn how the system works.  If you want to download PDFs for Application for Payments,
    //       Continuation Sheets, and Change Order Sheets, sign up for a full unlimited
    //       subscription. <b>First 30 days $0</b>
    //     </p>
    //     <p>
    //       <LearnMore/>
    //     </p>
    //   </Message>
    // );
    return (
      <div style={{ padding: '0', lineHeight: '1.4' }}>
        <h2 style={{ margin: '0 0 6px 0', lineHeight: '1.4' }}>OR</h2>
        <h2 style={{ margin: '6px 0', lineHeight: '1.4' }}>
          <span >Upgrade now to an <span style={{ textDecoration: 'underline' }}>Unlimited</span> Subscription Risk Free</span>
          <Button color="green" size="medium" as={Link} to={'/subscription/select'} style={{ marginLeft: '10px'  }}><strong>Subscribe Now</strong></Button>
        </h2>
        <h3 style={{ margin: '6px 0', lineHeight: '1.4' }}>Cancel any time during the first 30 days and your credit card will never be charged</h3>
      </div>
    );
    
  }
}
